module.exports = __webpack_public_path__ + "stylesheets/open-editor_1f61c246e670e77e170379f2e04c902b.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/open-editor.less
// module id = sM/Y
// module chunks = 151